import { camelizeKeys } from 'humps';
import { post, postAsJson } from '@namespace/helpers';

export const sendVerificationEmail = () =>
  post('/accounting/api/v1/email-tokens');

export const emailConfirmation = async (token) =>
  postAsJson('/service/pds/v1/confirm_email/confirm', {
    token_id: token
  }).then((data) => camelizeKeys(data));
